import { formInput, formInputPhone, formRadioGroup, formRow } from '@rocketfinancialcorp/rocket-ui/form';

import { Patterns } from '../patterns';

const createCounterpartyNameOptions = {
  expressions: {
    'props.disabled': 'model.accountHolderType === "CUSTOMER" && model.customerType === "BUSINESS"',
  },
};

const createCounterpartyOptions = {
  expressions: {
    'props.disabled': 'model.accountHolderType !== "COUNTERPARTY"',
  },
};
const createBusinessCounterpartyOptions = {
  expressions: {
    'props.required': 'model.counterpartyType === "BUSINESS"',
    hide: "model.counterpartyType === 'INDIVIDUAL'",
    'props.disabled': 'model.accountHolderType !== "COUNTERPARTY" ',
  },
};

export const counterpartyCreateFields = [
  formRow([
    formRadioGroup({
      key: 'counterpartyType',
      label: 'Counterparty Type',
      props: {
        options: [
          { value: 'INDIVIDUAL', label: 'Individual' },
          { value: 'BUSINESS', label: 'Business' },
        ],
      },
    }),
  ]),
  formRow([
    formInput({
      key: 'businessName',
      label: 'Business Name on Account',
      props: { pattern: Patterns.GENERIC_NAME, minLength: 1, maxLength: 100 },
      validation: { messages: { pattern: 'Enter a valid Business Name on Account' } },
      ...createBusinessCounterpartyOptions,
    }),
  ]),
  formRow([
    formInput({
      key: 'firstName',
      label: 'First name',
      props: { required: true, minLength: 1, maxLength: 40 },
      expressions: {
        'props.disabled': 'model.accountHolderType === "CUSTOMER" && model.customerType === "BUSINESS"',
        'props.required': 'model.counterpartyType === "INDIVIDUAL"',
      },
    }),
    formInput({ key: 'middleName', label: 'Middle name', props: { minLength: 1, maxLength: 40 }, ...createCounterpartyNameOptions }),
    formInput({
      key: 'lastName',
      label: 'Last name',
      props: { minLength: 1, maxLength: 40 },
      ...createCounterpartyNameOptions,
    }),
  ]),
  formRow([
    formInput({
      key: 'email',
      label: 'Email address',
      props: { pattern: Patterns.EMAIL, type: 'email', required: false, minLength: 1, maxLength: 100 },
      validation: {
        messages: {
          pattern: 'Enter a valid email',
        },
      },
      ...createCounterpartyOptions,
    }),
    formInputPhone({
      key: 'phoneNumber',
      label: 'Mobile Number',
      props: { required: false, minLength: 10, maxLength: 40, countryRestrictions: [], shouldKeepPhoneNumber: true },
      validators: { validation: [{ name: 'isValidPhoneNumber' }] },
      ...createCounterpartyOptions,
    }),
  ]),
];
